export var tableMenuTriggerHeaderCellTheme = {
  baseStyle: {
    display: 'flex',
    width: '100%'
  },
  variants: {
    light: {},
    dark: {
      color: 'neutral.darkest'
    }
  }
};
//# sourceMappingURL=_TableMenuTriggerHeaderCell.theme.js.map